import { Panel, Badge, PAY_STATUS, PAYMENT, Progress, Empty, fmtDate, fmtEur, fmtTime } from "@/admin/ui";

const WELCOME = { sent: "Enviado", failed: "Falló", pending: "Pendiente" };

export const PersonalTab = ({ s }) => (
  <Panel title="Datos personales" testid="admin-student-personal">
    <dl className="adm-dl">
      <dt>Nombre</dt><dd>{s.name}</dd>
      <dt>Email</dt><dd>{s.email}</dd>
      <dt>Fecha de alta</dt><dd>{fmtDate(s.created_at, true)}</dd>
      <dt>Consentimiento</dt><dd>{fmtDate(s.personal.consent_at, true)}</dd>
      <dt>Email de bienvenida</dt><dd>{WELCOME[s.personal.welcome_email_status] || "—"}</dd>
      <dt>Rol</dt><dd>{s.role === "admin" ? "Admin" : "Alumno"}</dd>
    </dl>
  </Panel>
);

export const SubscriptionTab = ({ s }) => {
  const sub = s.subscription;
  return (
    <div className="adm-grid">
      <Panel title="Suscripción" testid="admin-student-subscription">
        <dl className="adm-dl">
          <dt>Estado</dt><dd><Badge map={PAY_STATUS} value={sub.status} /></dd>
          <dt>Plan</dt><dd>{sub.plan_name || "Sin plan"}</dd>
          <dt>Facturación</dt><dd>{sub.interval ? (sub.interval === "year" ? "Anual" : "Mensual") : "—"} {sub.amount ? `· ${fmtEur(sub.amount)}` : ""}</dd>
          <dt>Acceso hasta</dt><dd>{fmtDate(sub.paid_until)}</dd>
          <dt>Próximo cobro</dt><dd data-testid="admin-student-next-charge">{sub.next_charge ? fmtDate(sub.next_charge) : "No hay cobros programados"}</dd>
        </dl>
      </Panel>
      <Panel title="Historial de pagos" testid="admin-student-payments">
        {!sub.history.length ? <Empty text="Este alumno todavía no tiene pagos." /> : sub.history.map((p) => (
          <div key={p.id} className="adm-list-item">
            <span>{fmtDate(p.created_at)} · {p.kind === "renovación" ? "Renovación" : "Alta"}</span>
            <span className="adm-row"><b>{fmtEur(p.amount)}</b><Badge map={PAYMENT} value={p.status} /></span>
          </div>
        ))}
      </Panel>
    </div>
  );
};

export const ProgressTab = ({ s }) => (
  <Panel title="Progreso" action={<span className="adm-sub">Tiempo total: {fmtTime(s.total_seconds)}</span>} testid="admin-student-progress">
    <div style={{ maxWidth: 360, marginBottom: "1rem" }}><Progress value={s.progress} /></div>
    <div className="adm-table-wrap">
      <table className="adm-table">
        <thead><tr><th>Módulo</th><th>Estado</th><th>Completado</th><th className="num">Tiempo</th></tr></thead>
        <tbody>{s.modules.map((m) => (
          <tr key={m.id} data-testid={`admin-student-module-${m.id}`}>
            <td>{m.number}. {m.title}</td>
            <td>{m.completed ? <span className="adm-badge ok">Completado</span> : <span className="adm-badge mute">Pendiente</span>}</td>
            <td className="adm-sub">{fmtDate(m.completed_at)}</td>
            <td className="num">{fmtTime(m.seconds)}</td>
          </tr>))}
        </tbody>
      </table>
    </div>
  </Panel>
);

export const AccessTab = ({ s }) => (
  <div className="adm-grid adm-two">
    <Panel title="Accesos" testid="admin-student-access">
      <dl className="adm-dl">
        <dt>Último login</dt><dd>{fmtDate(s.access.last_login, true)}</dd>
        <dt>Última actividad</dt><dd>{fmtDate(s.access.last_seen, true)}</dd>
        <dt>Frecuencia</dt><dd data-testid="admin-student-logins">{s.access.logins_30d} entradas en 30 días</dd>
      </dl>
      <h3 style={{ fontSize: 13, margin: "1.25rem 0 .4rem" }}>Últimas entradas</h3>
      {!s.access.recent.length ? <Empty text="Sin entradas registradas todavía." /> : s.access.recent.map((r, i) => (
        <div key={i} className="adm-list-item"><span className="adm-sub">{r.device} · {r.ip}</span><span className="adm-sub">{fmtDate(r.created_at, true)}</span></div>
      ))}
    </Panel>
    <Panel title="Dispositivos" testid="admin-student-devices">
      {!s.access.devices.length ? <Empty text="Sin dispositivos registrados." /> : s.access.devices.map((d) => (
        <div key={d.device} className="adm-list-item"><span>{d.device}</span><span className="adm-sub">{d.count} entradas · {fmtDate(d.last)}</span></div>
      ))}
    </Panel>
  </div>
);

export const ConsumedTab = ({ s }) => (
  <Panel title="Contenido consumido" testid="admin-student-consumed">
    {!s.consumed.length ? <Empty text="Aún no ha abierto ningún módulo desde que se registra la actividad." /> : s.consumed.map((c) => (
      <div key={c.module_id} className="adm-list-item"><span>{c.title}</span><span className="adm-sub">{c.views} visitas · última {fmtDate(c.last, true)}</span></div>
    ))}
  </Panel>
);
